import * as types from '@/store/mutation-types';

const mutations = {
  [types.SET_SOCIAL_ACTIVE](state, p) {
    const drp = p.drp;
    drp.socialIcons[p.index].active = p.active;
  },
  [types.SET_SOCIAL_LINK](state, p) {
    const drp = p.drp;
    drp.socialIcons[p.index].link = p.link;
  },
};

const actions = {
  setSocialActive: ({ commit }, payload) => {
    commit(types.SET_SOCIAL_ACTIVE, payload);
  },
  setSocialLink: ({ commit }, payload) => {
    commit(types.SET_SOCIAL_LINK, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/social-media/vuex.js